import { businessStore, userStore } from 'entities/index';
import { observer } from 'mobx-react';
import { Loading } from 'pages/loading/ui/loading.page';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CardWithOverlay, PageLayout } from 'shared/ui';
import {
  BusinessHeader,
  CalendarCard,
  DayCalendarWidget,
  EmployeesCard,
  Header,
  ManagersCard,
  ServicesCard,
} from 'widgets';

export const PointPage: React.FC = observer(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof id == 'string') {
      businessStore.pointId = id;
      businessStore.initPointHeaderData(id);
    } else {
      userStore.redirectToRoleBasedPage(navigate);
    }
  }, [id]);

  return id ? (
    <PageLayout>
      <Header />
      <BusinessHeader pointPage={true} />
      <DayCalendarWidget />
      <CardWithOverlay title="Создание записи">
        <CalendarCard />
      </CardWithOverlay>
      {/* <CardWithOverlay title="Рабочий календарь на день"> */}
      {/* </CardWithOverlay> */}
      <CardWithOverlay title="Услуги">
        <ServicesCard />
      </CardWithOverlay>
      <CardWithOverlay title="Менеджеры">
        <ManagersCard pointId={id} />
      </CardWithOverlay>
      <CardWithOverlay title="Сотрудники">
        <EmployeesCard pointId={id} />
      </CardWithOverlay>
    </PageLayout>
  ) : (
    <Loading />
  );
});
